// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type GraphViz_NodeConfigFragment = { __typename?: 'EntityGraphNodeConfiguration', nodeID: string, hidden?: boolean | null, xPosition?: number | null, yPosition?: number | null, height?: number | null, width?: number | null, fontSize?: string | null, notes?: string | null, type?: string | null, iconShape?: string | null, tileEmphasis?: string | null, dimensionsFinalized?: boolean | null, estateWaterfallConfig?: { __typename?: 'EstateWaterfallEntityGraphNodeConfig', hideGroupContents?: boolean | null, showTaxBreakout?: boolean | null } | null };

export const Operations = {
  Fragment: {
    GraphViz_NodeConfig: 'GraphViz_NodeConfig' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GraphViz_NodeConfigFragmentDoc = gql`
    fragment GraphViz_NodeConfig on EntityGraphNodeConfiguration {
  nodeID
  hidden
  xPosition
  yPosition
  height
  width
  fontSize
  notes
  type
  iconShape
  tileEmphasis
  dimensionsFinalized
  estateWaterfallConfig {
    hideGroupContents
    showTaxBreakout
  }
}
    `;